/*
1. Generate UTC timestamp from date object
2. Generate human readable date string from UTC timestamp
3. Remove time from timestamp (00:00hrs) and return UTC timestamp
4. Add/Set (months, days, hours) to UTC timestamp and return UTC timestamp
5. getTimeStringFromMilliseconds
6. getHoursFromMilliseconds
7. getMillisecondsFromHours
8. getMillisecondsFromTimeString
*/

export const getLocalMidnight = (timestamp) => {
  let dateObject = new Date(timestamp)
  let year = dateObject.getFullYear()
  let month = dateObject.getMonth()
  let date = dateObject.getDate()

  return new Date(year, month, date).getTime()
}

export const getTimeStampFromDateObject = (dateObject) => {
  // Get UTC timestamp from date object
  let timestamp = dateObject.getTime()

  return timestamp
}

export const getMidnightTimestampFromDateObject = (dateObject) => {
  // Return UTC midnight timestamp from date object
  let timestamp = dateObject.getTime()
  let midnightTimestamp = timestamp - (timestamp % 86400000)

  return midnightTimestamp
}

export const getMidnightTimestampFromTimestamp = (timestamp) => {
  return timestamp - (timestamp % 86400000)
}

export const getMidnightDateObjectFromTimestamp = (timestamp) => {
  let midnightTimestamp = timestamp - (timestamp % 86400000)
  let midnightDateObject = new Date(midnightTimestamp)

  return midnightDateObject
}

export const getHumanReadableDateTimeStringFromTimestamp = (timestamp, { showDate = true, showTime = true } = {}) => {
  let options = {
    date: {
      year: 'numeric', // '2-digit'
      month: 'short', // '2-digit', 'numeric', 'short'
      day: 'numeric'
    },
    time: {
      hour: 'numeric', // 'numeric'
      minute: 'numeric', // 'numeric'
      second: 'numeric', // 'numeric'
      hour12: true, // false
      timeZone: 'Europe/Zurich', // REF: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
      timeZoneName: 'short' // 'long'
    }
  }

  return (
    new Intl
      .DateTimeFormat(
        'en',
        {
          ...showDate ? options.date : {},
          ...showTime ? options.time : {}
        }
      )
      .format(timestamp)
  )
}

export const addTimeDeltaToTimestamp = (
  currentTimestamp,
  {
    years = 0,
    months = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
    milliseconds = 0
  } = {}
) => {
  let currentDateObject = new Date(currentTimestamp)

  let year = currentDateObject.getUTCFullYear()
  let month = currentDateObject.getUTCMonth()
  let day = currentDateObject.getUTCDate()
  let hour = currentDateObject.getUTCHours()
  let minute = currentDateObject.getUTCMinutes()
  let second = currentDateObject.getUTCSeconds()
  let millisecond = currentDateObject.getUTCMilliseconds()

  return Date.UTC(
    year + years,
    month + months,
    day + days,
    hour + hours,
    minute + minutes,
    second + seconds,
    millisecond + milliseconds
  )
}

export const getTimeStringFromMilliseconds = (milliseconds) => {
  let millisecondsInAMinute = 60 * 1000
  let millisecondsInAnHour = 60 * millisecondsInAMinute

  let hours = Math.floor(milliseconds / millisecondsInAnHour)
  let minutes =
    (milliseconds % millisecondsInAnHour) / millisecondsInAMinute

  hours = hours.toString()
  hours = hours.length === 2 ? hours : `0${hours}`
  minutes = minutes.toString()
  minutes = minutes.length === 2 ? minutes : `0${minutes}`

  return `${hours}:${minutes}`
}

export const getHoursFromMilliseconds = (milliseconds) => {
  let millisecondsInAnHour = 60 * 60 * 1000
  return Math.floor(milliseconds / millisecondsInAnHour)
}

export const getMillisecondsFromHours = (hours) => {
  let millisecondsInAnHour = 60 * 60 * 1000
  return Math.floor(hours * millisecondsInAnHour)
}

export const getMillisecondsFromTimeString = (string) => {
  let split = string.split(':')
  let hours = split[0]
  let minutes = split[1]

  hours = hours * 60 * 60 * 1000
  minutes = minutes * 60 * 1000

  return hours + minutes
}

export default {
  methods: {
    getLocalMidnight,
    getTimeStampFromDateObject,
    getMidnightTimestampFromDateObject,
    getMidnightTimestampFromTimestamp,
    getMidnightDateObjectFromTimestamp,
    getHumanReadableDateTimeStringFromTimestamp,
    addTimeDeltaToTimestamp,
    getTimeStringFromMilliseconds,
    getHoursFromMilliseconds,
    getMillisecondsFromHours,
    getMillisecondsFromTimeString
  }
}
